export var PrivacyStatus;
(function (PrivacyStatus) {
    /** No defined privacy status. */
    PrivacyStatus["UNDEFINED"] = "UNDEFINED";
    /** Profile details, such as profile name and profile picture, are visible to other members. */
    PrivacyStatus["PUBLIC"] = "PUBLIC";
    /** Profile details aren't visible to other members. */
    PrivacyStatus["PRIVATE"] = "PRIVATE";
})(PrivacyStatus || (PrivacyStatus = {}));
export var EmailTag;
(function (EmailTag) {
    EmailTag["UNTAGGED"] = "UNTAGGED";
    EmailTag["MAIN"] = "MAIN";
    EmailTag["HOME"] = "HOME";
    EmailTag["WORK"] = "WORK";
})(EmailTag || (EmailTag = {}));
export var PhoneTag;
(function (PhoneTag) {
    PhoneTag["UNTAGGED"] = "UNTAGGED";
    PhoneTag["MAIN"] = "MAIN";
    PhoneTag["HOME"] = "HOME";
    PhoneTag["MOBILE"] = "MOBILE";
    PhoneTag["WORK"] = "WORK";
    PhoneTag["FAX"] = "FAX";
})(PhoneTag || (PhoneTag = {}));
export var AddressTag;
(function (AddressTag) {
    AddressTag["UNTAGGED"] = "UNTAGGED";
    AddressTag["HOME"] = "HOME";
    AddressTag["WORK"] = "WORK";
    AddressTag["BILLING"] = "BILLING";
    AddressTag["SHIPPING"] = "SHIPPING";
})(AddressTag || (AddressTag = {}));
export var StateType;
(function (StateType) {
    /** Initial unknown state. */
    StateType["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    /** Login completed successfully. */
    StateType["SUCCESS"] = "SUCCESS";
    /** Indicates that the member needs the owner to approve their registration. */
    StateType["REQUIRE_OWNER_APPROVAL"] = "REQUIRE_OWNER_APPROVAL";
    /** Indicates that the member needs to verify their email. */
    StateType["REQUIRE_EMAIL_VERIFICATION"] = "REQUIRE_EMAIL_VERIFICATION";
    /** Indicates that the `status` is not one that prevents the member logging in, meaning it's not `OFFLINE`, `BLOCKED`, or `DELETED`. */
    StateType["STATUS_CHECK"] = "STATUS_CHECK";
    StateType["REQUIRE_MFA"] = "REQUIRE_MFA";
    /** Indicates that the member needs to verify themselves using the selected verication factor type. */
    StateType["MFA_CHALLENGE"] = "MFA_CHALLENGE";
})(StateType || (StateType = {}));
export var StatusName;
(function (StatusName) {
    StatusName["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    StatusName["PENDING"] = "PENDING";
    StatusName["ACTIVE"] = "ACTIVE";
    StatusName["DELETED"] = "DELETED";
    StatusName["BLOCKED"] = "BLOCKED";
    StatusName["OFFLINE"] = "OFFLINE";
})(StatusName || (StatusName = {}));
export var Reason;
(function (Reason) {
    Reason["UNKNOWN_REASON"] = "UNKNOWN_REASON";
    Reason["PENDING_ADMIN_APPROVAL_REQUIRED"] = "PENDING_ADMIN_APPROVAL_REQUIRED";
    Reason["PENDING_EMAIL_VERIFICATION_REQUIRED"] = "PENDING_EMAIL_VERIFICATION_REQUIRED";
})(Reason || (Reason = {}));
export var FactorType;
(function (FactorType) {
    /** Unknown factor type. */
    FactorType["UNKNOWN_FACTOR_TYPE"] = "UNKNOWN_FACTOR_TYPE";
    /** Requires a password. */
    FactorType["PASSWORD"] = "PASSWORD";
    /** Requires a code sent via SMS. */
    FactorType["SMS"] = "SMS";
    /** Requires a code sent by phone call. */
    FactorType["CALL"] = "CALL";
    /** Requires a code sent by email. */
    FactorType["EMAIL"] = "EMAIL";
    /** Requires authentication via an authenticator app. */
    FactorType["TOTP"] = "TOTP";
    /** Requires authentication via a push notification. */
    FactorType["PUSH"] = "PUSH";
})(FactorType || (FactorType = {}));
export var Status;
(function (Status) {
    /** Factor requires activation. */
    Status["INACTIVE"] = "INACTIVE";
    /** Factor is active and can be used for authentication. */
    Status["ACTIVE"] = "ACTIVE";
    /** Factor is blocked and cannot be used for authentication. The user should reenroll the factor. */
    Status["REQUIRE_REENROLL"] = "REQUIRE_REENROLL";
})(Status || (Status = {}));
export var FactorStatus;
(function (FactorStatus) {
    FactorStatus["UNKNOWN_FACTOR_STATUS"] = "UNKNOWN_FACTOR_STATUS";
    FactorStatus["ENABLED"] = "ENABLED";
    FactorStatus["REQUIRE_ACTIVATION"] = "REQUIRE_ACTIVATION";
    FactorStatus["REQUIRE_REENROLL"] = "REQUIRE_REENROLL";
    FactorStatus["ENABLED_BY_RULE"] = "ENABLED_BY_RULE";
    FactorStatus["DISABLED_BY_RULE"] = "DISABLED_BY_RULE";
})(FactorStatus || (FactorStatus = {}));
export var MfaReason;
(function (MfaReason) {
    MfaReason["UNKNOWN_MFA_REASON"] = "UNKNOWN_MFA_REASON";
    /** Mfa is required due to user settings */
    MfaReason["USER_SETTINGS"] = "USER_SETTINGS";
    /** Mfa is required due to high risk login */
    MfaReason["HIGH_RISK_LOGIN"] = "HIGH_RISK_LOGIN";
})(MfaReason || (MfaReason = {}));
export var TenantType;
(function (TenantType) {
    TenantType["UNKNOWN_TENANT_TYPE"] = "UNKNOWN_TENANT_TYPE";
    TenantType["ACCOUNT"] = "ACCOUNT";
    TenantType["SITE"] = "SITE";
    TenantType["ROOT"] = "ROOT";
})(TenantType || (TenantType = {}));
//# sourceMappingURL=types.impl.js.map